import { ImageName } from "@mcleod/images";
import {
    Button,
    Label,
    TableRow,
    TableRowCreationEvent,
    TableRowDisplayEvent,
    Textbox,
    ClickEvent,
    Component,
    ChangeEvent, Snackbar, LookupModelSearchEvent
} from "@mcleod/components";
import { AutogenLayoutLoadboardUsersDatRest } from "./autogen/AutogenLayoutLoadboardUsersDatRest";
import {Api, ModelRow, StringUtil} from "@mcleod/core";
import {CommonDialogs} from "@mcleod/common";


export class LoadboardUsersDatRest extends AutogenLayoutLoadboardUsersDatRest {

    async onLoad() {
        await this.sourceLmeUserToken.search({is_dat_loadboard: "Y"})
    }


      buttonDeleteOnClick(event: ClickEvent) {
         const tableRow = this.tableDatLoadboardRestUsers.findTableRowFromAdditionalTool(event.target as Button);
         const modelRow = tableRow.data;

          CommonDialogs.showYesNo("Are you sure you want to delete this record?", "Confirm Deletion", {
              xVisible: true
          }, false).then(async clicked => {
              if (clicked) {
                  Api.post("lme/general/update/service-type", {
                      "called_from": "L",
                      "user_id": modelRow.get("user_id")
                  }).then(result => {
                      if (result?.data[0]?.success) {
                          this.tableDatLoadboardRestUsers.removeRow(modelRow);
                      } else {
                          Snackbar.showWarningSnackbar("Unable to delete user.");
                      }
                  });
              }
          });
     }

    tableDatLoadboardRestUsersOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow: ModelRow = tableRow.data;

        const isUserTokenValid = modelRow.get("is_valid_token", false);
        const errorMessage = modelRow.get("user_auth_error");
        const textboxUserId = tableRow.findComponentById("textboxUserId") as Textbox;
        const textboxDatUserId = tableRow.findComponentById("textboxDatUserId") as Textbox;
        textboxUserId.text = modelRow.get("user_id");
        textboxDatUserId.text = modelRow.get("dat_user_id");
        this.setupUserAuthorizationLabel(isUserTokenValid, tableRow, errorMessage);
        if (this.tableDatLoadboardRestUsers.quickAddRow === tableRow) {
            const labelDatStatus = tableRow.findComponentById("labelDatStatus") as Label;
            const buttonDatRestUserAuthorize = tableRow.findComponentById("buttonDatRestUserAuthorize") as Button;

            if (buttonDatRestUserAuthorize) {
                buttonDatRestUserAuthorize.visible = false;
            }
            if (labelDatStatus) {
                labelDatStatus.visible = false;
            }
        }
   }

    tableDatLoadboardRestUsersOnRowCreate(event: TableRowCreationEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data;
        if (modelRow._appending) {
            if (this.tableDatLoadboardRestUsers.quickAddRow !== tableRow) {
                Api.post("lme/general/rateindex/rateview/auth", {
                    "action_type": "UL",
                    "user_id": modelRow.get("user_id"),
                    "dat_rateview_user": modelRow.get("dat_user_id")
                }).then(response => {
                    if (response?.data[0]?.is_valid_token) {
                        modelRow.set("is_valid_token", true);
                        this.setUserAuthSuccess(tableRow)
                    } else {
                        this.setUserAuthFailed(tableRow, response?.data[0].dat_user_auth_error);
                        modelRow.set("is_valid_token", false);
                        if(StringUtil.equalsIgnoreCase(response.data[0].dat_user_auth_error, "Authentication is blocked for one minute.")) {
                            Snackbar.showWarningSnackbar("Authentication is blocked for one minute.");
                        }
                    }
                });
            } else {
                // Turn off buttonDatRestUserAuthorize for quick add row
                const buttonDatRestUserAuthorize = tableRow.findComponentById("buttonDatRestUserAuthorize") as Button;
                const labelDatStatus = tableRow.findComponentById("labelDatStatus") as Label;

                if (buttonDatRestUserAuthorize) {
                    buttonDatRestUserAuthorize.visible = false;
                }
                if (labelDatStatus) {
                    labelDatStatus.visible = false;
                }
            }
        }
    }

    private setUserAuthSuccess(tableRow: TableRow) {
        const textboxUserId = tableRow.findComponentById("textboxUserId") as Textbox;
        const textboxDatUserId = tableRow.findComponentById("textboxDatUserId") as Textbox;
        const labelDatStatus = tableRow.findComponentById("labelDatStatus") as Label;
        const buttonDatRestUserAuthorize = tableRow.findComponentById("buttonDatRestUserAuthorize") as Button;
        labelDatStatus.imageName = ImageName.circleCheck;
        labelDatStatus.imageColor = "success";
        labelDatStatus.tooltip = "User is successfully authenticated.";
        textboxUserId.enabled = false;
        textboxDatUserId.enabled = true;
        labelDatStatus.visible = true;
        buttonDatRestUserAuthorize.visible = false;
    }

    private setUserAuthFailed(tableRow: TableRow, errorMessage: string) {
        const textboxUserId = tableRow.findComponentById("textboxUserId") as Textbox;
        const textboxDatUserId = tableRow.findComponentById("textboxDatUserId") as Textbox;
        const labelDatStatus = tableRow.findComponentById("labelDatStatus") as Label;
        const buttonDatRestUserAuthorize = tableRow.findComponentById("buttonDatRestUserAuthorize") as Button;
        labelDatStatus.imageName = ImageName.circleX;
        labelDatStatus.imageColor = "error";
        labelDatStatus.tooltip = errorMessage;
        textboxUserId.enabled = true;
        textboxDatUserId.enabled = true;
        labelDatStatus.visible = true;
        buttonDatRestUserAuthorize.visible = true;
    }

    private setupUserAuthorizationLabel(isUserTokenValid: boolean, tableRow: TableRow, errorMessage: any) {
        if (isUserTokenValid) {
            this.setUserAuthSuccess(tableRow);
        } else {
            this.setUserAuthFailed(tableRow, errorMessage);
        }
    }



    /** This is an event handler for the onClick event of buttonDatRestUserAuthorize. */
    buttonDatRestUserAuthorizeOnClick(event: ClickEvent) {
        const tableRow = TableRow.getContainingTableRow(event.target as Component);
        const textboxUserId = tableRow.findComponentById("textboxUserId") as Textbox;
        const textboxDatUserId = tableRow.findComponentById("textboxDatUserId") as Textbox;

        Api.post("lme/general/rateindex/rateview/auth", {
            "action_type": "UL",
            "user_id": textboxUserId.text,
            "dat_rateview_user": textboxDatUserId.text
        }).then(response => {
            if (response?.data[0]?.is_valid_token) {
                tableRow.data.set("is_valid_token", true);
                this.setUserAuthSuccess(tableRow)
            } else {
                this.setUserAuthFailed(tableRow, response?.data[0].dat_user_auth_error);
                tableRow.data.set("is_valid_token", false);
                if(StringUtil.equalsIgnoreCase(response.data[0].dat_user_auth_error, "Authentication is blocked for one minute.")) {
                    Snackbar.showWarningSnackbar("Authentication is blocked for one minute.");
                }
            }
        });
    }


    textboxDatUserIdOnChange(event: ChangeEvent) {
        const tableRow = TableRow.getContainingTableRow(event.target as Component);
        const modelRow = tableRow.data;

        const isExistingRow = !modelRow._appending &&
            this.tableDatLoadboardRestUsers.quickAddRow !== tableRow;

        if (event.userInitiatedChange && isExistingRow) {
            const buttonDatRestUserAuthorize = tableRow.findComponentById("buttonDatRestUserAuthorize") as Button;
            const labelDatStatus = tableRow.findComponentById("labelDatStatus") as Label;

            buttonDatRestUserAuthorize.visible = true;
            labelDatStatus.visible = false;
        }
    }

    textboxUserIdBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_rateview = false;
    }
}
